export default "__VITE_PUBLIC_ASSET__55cc19f4__"